<div class="modal-header" mat-dialog-title>
  <div class="modal-header-titles">
    <h2 class="modal-title">Enviar formulário de cotação</h2>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <p>
    @if (temReenvio) {
      Estes fornecedores ainda não receberam o formulário ou tiveram o link desativado porque os
      produtos mudaram. Confirme para quem enviar — o e-mail usa o template de Comunicação de cotação.
    } @else {
      Estes fornecedores ainda não receberam o formulário. Confirme para quem enviar —
      o e-mail usa o template de Comunicação de cotação.
    }
  </p>

  <ul class="lista">
    @for (f of data.fornecedores; track f.idCotacaoFornecedor) {
      <li class="item" [class.item--sem-email]="!f.email">
        <!-- Sem e-mail o fornecedor não pode ser marcado: o motivo aparece ao lado e no tooltip. -->
        <span [matTooltipDisabled]="!!f.email"
          [matTooltip]="f.cadastroIndisponivel
            ? 'Não foi possível carregar o e-mail do fornecedor.'
            : 'Fornecedor sem e-mail cadastrado.'">
          <mat-checkbox [checked]="selecionados.has(f.idCotacaoFornecedor)" [disabled]="!f.email"
            (change)="alternar(f)">
            <span class="nome">{{ f.nome }}</span>
            @if (f.reenvio) {
              <span class="reenvio">reenvio · link desativado</span>
            }
          </mat-checkbox>
        </span>
        @if (f.email) {
          <span class="email">{{ f.email }}</span>
        } @else if (f.cadastroIndisponivel) {
          <span class="sem-email">
            <mat-icon class="material-symbols-outlined">cloud_off</mat-icon>
            não foi possível carregar o e-mail
          </span>
        } @else {
          <span class="sem-email">
            <mat-icon class="material-symbols-outlined">error</mat-icon>
            sem e-mail cadastrado
          </span>
        }
      </li>
    }
  </ul>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Agora não</button>
  <span matTooltip="Selecione ao menos um fornecedor com e-mail." [matTooltipDisabled]="selecionados.size > 0">
    <button mat-flat-button type="button" class="btn-primary" [disabled]="!selecionados.size" (click)="confirmar()">
      <mat-icon class="material-symbols-outlined">send</mat-icon>
      Enviar para {{ selecionados.size }}
    </button>
  </span>
</mat-dialog-actions>
